import React from "react";
import { motion } from "framer-motion";
import SectionTitle from "./SectionTitle";
import { SPOTIFY_ALBUMS, STREAMING } from "../data/content";

const platforms = [
  { key: "spotify", label: "Spotify" },
  { key: "apple", label: "Apple Music" },
  { key: "deezer", label: "Deezer" },
  { key: "youtube", label: "YouTube" },
  { key: "soundcloud", label: "SoundCloud" },
];

export const Music = () => (
  <section id="musique" className="section bg-gradient-to-b from-[#050505] via-[#070710] to-[#050505] py-28">
    <div className="orb orb-blue" style={{ width: 420, height: 420, top: "0%", left: "-6%" }} />
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <SectionTitle kicker="Discographie" title="La bande-son de l'été" testid="music-title" />

      <div className="grid gap-8 lg:grid-cols-3">
        {SPOTIFY_ALBUMS.map((album, i) => (
          <motion.div
            key={album.id}
            data-testid={`album-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="glass overflow-hidden rounded-2xl p-4"
          >
            <div className="mb-4 flex items-baseline justify-between">
              <h3 className="font-display text-lg font-bold text-white">{album.title}</h3>
              <span className="gold-text font-heading text-sm">{album.year}</span>
            </div>
            <div className="overflow-hidden rounded-xl">
              <iframe
                data-testid={`spotify-embed-${i}`}
                title={album.title}
                src={`https://open.spotify.com/embed/album/${album.id}?theme=0`}
                width="100%"
                height="352"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                style={{ borderRadius: 12 }}
              />
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
        <span className="font-heading text-sm text-white/50">Disponible sur</span>
        {platforms.map((p) => (
          <a
            key={p.key}
            data-testid={`platform-${p.key}`}
            href={STREAMING[p.key]}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full border border-white/15 glass px-5 py-2 font-heading text-sm text-white/80 transition-all duration-300 hover:border-electric hover:text-white"
          >
            {p.label}
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Music;
